import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useGetAccountQuery } from '@/entities/account';

import { Header } from '@/widgets/header/ui';
import { Footer } from '@/widgets/footer/ui';
import { PushContainer } from '@/features/common/push/ui';
import { Confirmation } from '@/features/common/confirmation/ui';
import { Loader } from '@/features/common/loader/ui';

import cls from './styles.module.pcss';
import layoutCls from '@shared/assets/styles/modules/layout.module.pcss';
import backgroundMp4 from '@shared/assets/videos/background.mp4';
import background2160Mp4 from '@shared/assets/videos/background_2160.mp4';
import background1366Mp4 from '@shared/assets/videos/background_1366.mp4';
import backgroundWebm from '@shared/assets/videos/background.webm';
import background2160Webm from '@shared/assets/videos/background_2160.webm';
import background1366Webm from '@shared/assets/videos/background_1366.webm';

export function MainLayout() {
  const { t } = useTranslation()
  const { isLoading: isAuthLoading } = useGetAccountQuery();

  if (isAuthLoading) {
    return <Loader fit fullscreen />;
  }

  return (
    <div className={cls.mainLayout}>
      <Helmet>
        <title>{t('common.meta.title.main')}</title>
      </Helmet>

      <div className={cls.bg}>
        <video className={cls.video} muted loop autoPlay>
          <source src={backgroundWebm} type="video/webm" media='(min-width: 3840px)' />
          <source src={background2160Webm} type="video/webm" media='(min-width: 2160px)' />
          <source src={background1366Webm} type="video/webm" />

          <source src={backgroundMp4} type="video/webm" media='(min-width: 3840px)' />
          <source src={background2160Mp4} type="video/webm" media='(min-width: 2160px)' />
          <source src={background1366Mp4} type="video/webm" />
        </video>
      </div>
      <main className={cn(cls.content)}>
        <Header />
        <section className={cn(cls.route, layoutCls.Container)}>
          <Outlet />
        </section>
        <Footer />
      </main>

      <PushContainer />
      <Confirmation />
    </div>
  );
}
